export default {
	methods: {
		getReviewItemsSorted(items, groupSelector, categorySelector) {
			let groupedByGroup = _.groupBy(items, groupSelector);
			let result = [];

			for (let group in groupedByGroup) {
				result.push({
					group: group === 'null' ? null : group,
					type: this.getTypeFromText(group),
					items: []
				});

				// group by category
				let groupedByCategory = _.groupBy(groupedByGroup[group], categorySelector);
				for (let category in groupedByCategory) {
					result[result.length - 1].items.push({
						category: category === 'null' ? null : category,
						items: groupedByCategory[category]
					});
				}
			}

			let resultsOrdered = this.sortGroups(result);

			return resultsOrdered;
		},
		sortGroups(sortedData) {
			const sortTypeOrder = [99, 1, 2, 5, 0, 3, 4];
			let resultsOrdered = [];

			const naNullList = sortedData.filter(x => x.type === 99 && x.group === null);
			for (let i = 0; i < naNullList.length; i++) {
				resultsOrdered.push(naNullList[i]);
			}

			const naList = sortedData.filter(x => x.type === 99 && x.group !== null);
			for (let i = 0; i < naList.length; i++) {
				resultsOrdered.push(naList[i]);
			}

			const otherList = sortedData.filter(x => x.type !== 99);

			for (let i = 0; i < sortTypeOrder.length; i++) {
				for (let x = 0; x < otherList.length; x++) {
					if (otherList[x].type === sortTypeOrder[i]) {
						resultsOrdered.push(otherList[x]);
					}
				}
			}

			return resultsOrdered;
		}
	}
};
